import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
});
